import { configureStore } from "@reduxjs/toolkit";

// Dummy reducer to fix Redux store validation
const dummyReducer = (state = {}, action: any) => {
  return state;
};

export const store = configureStore({
  reducer: {
    app: dummyReducer
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
